<template>
    <b-card no-body>
        <b-modal id="payment" title="Ödeme Bilgisi Oluştur" no-close-on-esc no-close-on-backdrop size="lg">
            <traffic-fine-payment v-model="trafficFinePayment" :errors="errors" :fine-details="selectedFine"></traffic-fine-payment>
            <template #modal-footer><v-executer :loading="loading" text="Oluştur" :action="pay"></v-executer></template>
        </b-modal>

        <b-modal id="bulk-payment" title="Toplu Ödeme Bilgisi Oluştur" no-close-on-esc no-close-on-backdrop size="xl" scrollable>
            <traffic-fine-bulk-payment v-model="bulkPaymentForm" :selected-fines="bulkPayableFines"></traffic-fine-bulk-payment>
            <template #modal-footer><v-executer :loading="bulkLoading" text="Toplu Öde" :action="bulkPay"></v-executer></template>
        </b-modal>

        <v-table
            ref="table"
            :items-provider="provider"
            pagination="server"
            search
            selectable
            v-on:select="selectedFines = $event"
            :fields="fields"
            :buttons="buttons"
        >
            <template #additional-actions>
                <button
                    class="btn btn-primary btn-sm d-inline-flex align-items-center"
                    :disabled="selectedFines.length === 0"
                    v-on:click="openBulkPayment"
                >
                    <feather-icon icon="CreditCardIcon" class="mr-50"></feather-icon>
                    <span>Toplu Ödeme{{ selectedFines.length > 0 ? ` (${selectedFines.length})` : '' }}</span>
                </button>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import EmployeeOperationsApi from "@/api/employee-operations";
import TrafficFinePayment from "./components/TrafficFinePayment.vue";
import TrafficFineBulkPayment from "./components/TrafficFineBulkPayment.vue";
import Additional from "@/utilities/additional";

export default {
    components: {
        BCard,
        TrafficFinePayment,
        TrafficFineBulkPayment,
    },
    data() {
        return {
            fields: [
                { name: "Durum", key: "PaymentStatus", component: true, componentOptions: { name: "traffic-fine-payment/PaymentStatusBadge" }, thClass: "w-10 text-center", tdClass: "text-center" },
                { name: "Personel", key: "EmployeeFullName", thClass: "w-15", tdClass: "text-nowrap" },
                { name: "Tutanak No", key: "ReportNumber", thClass: "w-10", tdClass: "text-nowrap" },
                { name: "Ceza Maddesi", component: true, componentOptions: { name: "traffic-fine/TrafficFine" }, thClass: "w-10", tdClass: "text-right text-nowrap" },
                { name: "Ceza Tutarı (TL)", key: "PriceStr", thClass: "w-10 ", tdClass: "text-right text-nowrap" },
                { name: "Ceza Tarihi", key: "FineDateStr", thClass: "w-10", tdClass: "text-right text-nowrap" },
                { name: "Tebliğ Tarihi", key: "NotifyDateStr", thClass: "w-10", tdClass: "text-right text-nowrap" },
                { name: "Kayıt Tarihi", key: "CreateTimeStr", thClass: "w-10", tdClass: "text-right text-nowrap" },
                { name: "Ödenen Tutar (TL)", key: "PaidAmount", thClass: "w-10", tdClass: "text-right text-nowrap" },
                { name: "Ödeme Tarihi", key: "PaymentDateStr", thClass: "w-10", tdClass: "text-right text-nowrap" },
            ],
            buttons: [
                { text: "Ödeme Bilgisi Kaydet", key: "payment", icon: "CreditCardIcon", variant: "primary", action: this.payment },
                { text: "Ceza Belgesi İndir", key: "download_fine", icon: "DownloadIcon", variant: "secondary", action: this.downloadFineDocument, condition: (item) => item.FineDocument },
                { text: "Ödeme Dekontu İndir", key: "download_payment", icon: "DownloadIcon", variant: "success", action: this.downloadPaymentDocument, condition: (item) => item.PaymentDocument },
            ],
            errors: {},
            loading: false,
            bulkLoading: false,
            trafficFinePayment: {
                PaymentDate: null,
                PaymentPlace: null,
                BankId: null,
                TaxAdministrationId: null,
                EmployeeTrafficFineId: null,
                Document: null,
            },
            bulkPaymentForm: {
                PaymentDate: null,
                PaymentPlace: 0,
                BankId: null,
                TaxAdministrationId: null,
                Items: [],
            },
            selectedFine: null,
            selectedFines: [],
            bulkPayableFines: [],
        };
    },
    methods: {
        provider(data) {
            return EmployeeOperationsApi.TrafficFine.Payment.Table(data);
        },
        pay() {
            this.$confirm("Ödeme kaydı oluşturmak istediğinize emin misiniz?", "Bu işle netsise kayıt atacaktır.").then(async (res) => {
                if (res) {
                    this.loading = true;
                    let formData = await Additional.ToFormData(this.trafficFinePayment, ["Document"]);
                    EmployeeOperationsApi.TrafficFine.Payment.Create(formData)
                        .then((res) => {
                            this.$result(res);
                            this.loading = false;
                            if (res.data.Success) {
                                this.$hideModal("payment");
                                this.$refs.table.refresh();
                            }
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.$result(null, err);
                        });
                }
            });
        },
        openBulkPayment() {
            const payable = this.selectedFines.filter((f) => f.PaymentStatus !== 0);
            if (payable.length === 0) {
                this.$result({ data: { Success: false, Message: "Seçili cezaların tamamı zaten ödenmiş." } });
                return;
            }
            this.bulkPayableFines = payable;
            this.bulkPaymentForm.PaymentDate = null;
            this.bulkPaymentForm.PaymentPlace = 0;
            this.bulkPaymentForm.BankId = null;
            this.bulkPaymentForm.TaxAdministrationId = null;
            this.bulkPaymentForm.Items = payable.map((f) => ({ EmployeeTrafficFineId: f.EmployeeTrafficFineId, PaidAmount: 0 }));
            this.$showModal("bulk-payment");
        },
        bulkPay() {
            this.$confirm(
                `${this.bulkPaymentForm.Items.length} ceza için ödeme kaydı oluşturmak istediğinize emin misiniz?`,
                "Bu işlem netsise kayıt atacaktır."
            ).then((confirmed) => {
                if (!confirmed) return;
                this.bulkLoading = true;
                EmployeeOperationsApi.TrafficFine.Payment.BulkCreate(this.bulkPaymentForm)
                    .then((res) => {
                        this.bulkLoading = false;
                        if (res.data.Success) {
                            const data = res.data.Data;
                            this.$hideModal("bulk-payment");
                            this.$refs.table.refresh();
                            this.selectedFines = [];
                            if (data.FailCount === 0) {
                                this.$result({ data: { Success: true, Message: `${data.SuccessCount} ödeme başarıyla kaydedildi.` } });
                            } else {
                                const failLines = data.Results.filter((r) => !r.Success)
                                    .map((r) => `• ${r.ReportNumber || r.EmployeeTrafficFineId}: ${r.Message}`)
                                    .join("\n");
                                this.$result({ data: { Success: false, Message: `${data.SuccessCount} başarılı, ${data.FailCount} başarısız.\n\n${failLines}` } });
                            }
                        } else {
                            this.$result(res);
                        }
                    })
                    .catch((err) => {
                        this.bulkLoading = false;
                        this.$result(null, err);
                    });
            });
        },
        clearForm() {
            this.trafficFinePayment.PaymentDate = null;
            this.trafficFinePayment.PaymentPlace = null;
            this.trafficFinePayment.BankId = null;
            this.trafficFinePayment.TaxAdministrationId = null;
            this.trafficFinePayment.EmployeeTrafficFineId = null;
            this.trafficFinePayment.Document = null;
        },
        payment(item) {
            this.clearForm();
            this.selectedFine = item;
            this.trafficFinePayment.EmployeeTrafficFineId = item.EmployeeTrafficFineId;
            this.$showModal("payment");
        },
        downloadFineDocument(item) {
            this.$refs.table.rowLoading(true);
            Additional.GetBlobFile(item.FineDocument)
                .then((res) => {
                    const name = [["Ceza Belgesi", item.EmployeeFullName, item.ReportNumber].join("-"), Additional.GetExtension(item.FineDocument)].join(".");
                    Additional.DownloadFile(res.data, name);
                    this.$refs.table.rowLoading(false);
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.$refs.table.rowLoading(false);
                });
        },
        downloadPaymentDocument(item) {
            this.$refs.table.rowLoading(true);
            Additional.GetBlobFile(item.PaymentDocument)
                .then((res) => {
                    const name = [["Ödeme Dekontu", item.EmployeeFullName, item.ReportNumber].join("-"), Additional.GetExtension(item.PaymentDocument)].join(".");
                    Additional.DownloadFile(res.data, name);
                    this.$refs.table.rowLoading(false);
                })
                .catch((err) => {
                    this.$result(null, err);
                    this.$refs.table.rowLoading(false);
                });
        },
    },
};
</script>

<style></style>
